export const 
STORE_SS_FORM_FIELD = "STORE_SS_FORM_FIELD",
STORE_SS_FORM = "STORE_SS_FORM",
RESET_SS_FORM_DATA = 'RESET_SS_FORM_DATA',
FORM_UTILS_MARK_FORM_FIELD_ERROR_CODE = 'FORM_UTILS_MARK_FORM_FIELD_ERROR_CODE',
TOGGLE_REQUIRED_FORM_FIELD = 'TOGGLE_REQUIRED_FORM_FIELD';
